<div class="row drawer-content drawer-direct-content">
    <div class="col">
        <div>
            <div class="form-group">
                <div class="row mb-3">
                    <div class="col-md-12">
                        <label class="input-label field-required ml-0">{{ 'New service name' | translate }}</label>
                        <input class="form-control"
                                type="text"
                                name="name"
                                [(ngModel)]="serviceName"
                                [rangeLength]="[2, 256]"
                                required
                                autofocus>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-12">
                        <i id="copyService"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.copyService
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.copyService = !serviceCopyProperties.copyService;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Local copy (same instance)' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="serviceSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.serviceSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.serviceSelected = !serviceCopyProperties.serviceSelected; srviceSelected();" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Service (all elements)' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="registrationsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.registrationsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.registrationsSelected = !serviceCopyProperties.registrationsSelected; serviceCopyProperties.serviceSelected = false;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Registrations' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="determinantsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.determinantsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.determinantsSelected = !serviceCopyProperties.determinantsSelected; serviceCopyProperties.serviceSelected = false; determinantsSelected();" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Determinants' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="{{serviceCopyProperties && serviceCopyProperties.catalogsSelected && !serviceCopyProperties.copyService ? 'col-6' : 'col-12'}}">
                        <i id="catalogsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.catalogsSelected && !serviceCopyProperties.copyService
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.catalogsSelected = !serviceCopyProperties.catalogsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Catalogs' | translate}}</label>
                    </div>
                    <div class="col-6 {{serviceCopyProperties && serviceCopyProperties.catalogsSelected && !serviceCopyProperties.copyService ? '' : 'hidden'}}">
                        <div class="pull-right">
                <span (click)="selectAllCatalogues()"
                        class="mb-1">
                        <i id="catalogsSelected"
                            class="mr-1 fas {{serviceCopyProperties && allClassificationSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}" style="vertical-align: text-top;"></i><label class="input-label">{{'Select All' | translate}}</label></span>
                        </div>
                    </div>
                </div>
                <div class="row {{serviceCopyProperties && serviceCopyProperties.catalogsSelected && !serviceCopyProperties.copyService ? 'mb-3' : 'hidden'}}">
                    <div class="col-12">
                        <div class="d-flex">
                            <div class="w-100">
                                <div class="list-group list-group--slim">
                                    <ng-select [(ngModel)]="selectedCatalogues"
                                                bindLabel="text"
                                                bindValue="id"
                                                [clearable]="false"
                                                [multiple]="true"
                                                [items]="classifications"
                                                (add)="selectedCatalogue($event)"
                                                (remove)="removedCatalogue($event)"
                                                placeholder="Select catalogue(s)" class="multi-select-catalogues">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="guideFormSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.guideFormSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.guideFormSelected = !serviceCopyProperties.guideFormSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Guide' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="applicantFormSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.applicantFormSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.applicantFormSelected = !serviceCopyProperties.applicantFormSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Applicant form' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="sendFileFormSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.sendFileFormSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.sendFileFormSelected = !serviceCopyProperties.sendFileFormSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Send file form' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="paymentFormSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.paymentFormSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.paymentFormSelected = !serviceCopyProperties.paymentFormSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Payment form' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="rolesSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.rolesSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.rolesSelected = !serviceCopyProperties.rolesSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Roles' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="botsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.botsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.botsSelected = !serviceCopyProperties.botsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Bots' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="costsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.costsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.costsSelected = !serviceCopyProperties.costsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Costs' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="requirementsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.requirementsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.requirementsSelected = !serviceCopyProperties.requirementsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Requirements' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="resultsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.resultsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.resultsSelected = !serviceCopyProperties.resultsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Results' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="printDocumentsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.printDocumentsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.printDocumentsSelected = !serviceCopyProperties.printDocumentsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Print documents' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="activityConditionsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.activityConditionsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.activityConditionsSelected = !serviceCopyProperties.activityConditionsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Conditions' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="registrationLawsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.registrationLawsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.registrationLawsSelected = !serviceCopyProperties.registrationLawsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Laws' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="serviceLocationsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.serviceLocationsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.serviceLocationsSelected = !serviceCopyProperties.serviceLocationsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Collection places' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="serviceTutorialsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.serviceTutorialsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.serviceTutorialsSelected = !serviceCopyProperties.serviceTutorialsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Tutorials' | translate}}</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <i id="serviceTranslationsSelected"
                            class="fas {{serviceCopyProperties && serviceCopyProperties.serviceTranslationsSelected
                    ? 'fa-toggle-large-on toggle-primary'
                    : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'}}"
                            (click)="serviceCopyProperties.serviceTranslationsSelected = !serviceCopyProperties.serviceTranslationsSelected;" style="vertical-align: text-top;"></i>&nbsp;
                        <label class="input-label">{{'Translations' | translate}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
